// The package manager the visitor picked for the install widgets, remembered across visits.
import { useSyncExternalStore } from 'react';
import { installCommand, type PackageManager } from 'wobbli/formats';
import { PACKAGE_NAME, REGISTRY_URL } from '../config';

export const PMS: PackageManager[] = ['npm', 'pnpm', 'bun', 'shadcn'];
const KEY = 'agent-avatar-studio:pm';
let pm: PackageManager = (() => { try { const v = localStorage.getItem(KEY); return PMS.includes(v as PackageManager) ? (v as PackageManager) : 'npm'; } catch { return 'npm'; } })();
const ls = new Set<() => void>();
export function setPm(v: PackageManager) { pm = v; try { localStorage.setItem(KEY, v); } catch { /* this visit only */ } ls.forEach(f => f()); }
export const usePm = () => useSyncExternalStore(f => { ls.add(f); return () => { ls.delete(f); }; }, () => pm);
export const installText = (p: PackageManager) => installCommand(p, PACKAGE_NAME, REGISTRY_URL);
